export const SHARE_APIS = {
    whatsappDesktop: (shareText?: string) => `https://web.whatsapp.com/send?text=${shareText}`,
    whatsappPhone: (shareText?: string) => `whatsapp://send?text=${shareText}`,
    fb: (shareText?: string, url?: string) => `https://www.facebook.com/share.php?u=${url}&quote=${shareText}`,
    twitter: (shareText?: string, url?: string) => `https://www.twitter.com/share?text=${shareText}%0A&url=${url}`,
    email: (shareText?: string, url?: string, title?: string) => `mailto:?subject=${title}&body=${shareText}%0A${url}`,
    linkedIn: (shareText?: string, url?: string) =>
        `https://www.linkedin.com/shareArticle?mini=true?summary=${shareText}&url=${url}`
};
